module.exports = __webpack_public_path__ + "media/react/features/overview/suggestions/icons/mailchimp-icon-c6d90328bcdfc92f90561de26fd316dc.png";